import { Component, ChangeDetectorRef, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { UserDetailService } from './user-detail.service';
import { TeamSummaryService } from '../team-summary.service';
import { UserUpdateStatusService } from './user-update-status.service';
import { UserStorage } from './../../../../helper';
import { Roles } from './../../../../model';

import * as $ from 'jquery';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
  @ViewChild('deactivateBtn') deactivateBtn: ElementRef;
  @ViewChild('suspendBtn') suspendBtn: ElementRef;
  @ViewChild('editBtn') editBtn: ElementRef;
  @ViewChild('backBtn') backBtn: ElementRef; 

  userId = '';
  user: any;
  teams: any[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private userDetailService: UserDetailService,
    private userUpdateStatusService: UserUpdateStatusService,
    private chRef: ChangeDetectorRef,
    private teamSummaryService: TeamSummaryService,
    private userInfo: UserStorage
  ) {
      this.route.params.subscribe(params => { this.userId = params['id']; });
      this.translate.setDefaultLang('en-us');
    }

  ngOnInit() {

    var isMyProfile = (this.userId == null ? true : false);

    if (isMyProfile){
      this.userId = this.userInfo.getLocalUserID();
      this.teamSummaryService.getSummary().subscribe((data: any) => {
        this.teams = data;
  
        this.userDetailService
            .getLoginedDetail()
            .subscribe(
              userData => {
                this.user = userData;
                this.chRef.detectChanges();
                this.hideDeactiveBtn(userData);
                this.hideEdit_BackBtn(userData);
              },
              error => {
                this.user = {};
                this.chRef.detectChanges();
  
                $('.card').hide();
                this.exception.showError(error, 'showDanModalBtn');
              }
            );
      }, error => {
          $('.card').hide();
          this.exception.showError(error, 'showDanModalBtn');
        }
      );

    } else {
      this.teamSummaryService.getSummary().subscribe((data: any) => {
        this.teams = data;
  
        this.userDetailService
            .getDetail(this.userId)
            .subscribe(
              userData => {
                this.user = userData;
                this.chRef.detectChanges();
                this.hideDeactiveBtn(userData);
                this.hideEdit_BackBtn(userData);
              },
              error => {
                this.user = {};
                this.chRef.detectChanges();
  
                $('.card').hide();
                this.exception.showError(error, 'showDanModalBtn');
              }
            );
      }, error => {
          $('.card').hide();
          this.exception.showError(error, 'showDanModalBtn');
        }
      );
    }


  }

  errorClose() {
      this.router.navigate(['/home/users']);
  }

  activate() {
    if (this.user.isActive === 0) {
      this.updateStatus();
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }
  }

  deactivate() {
    if (this.user.isActive === 1) {
      this.updateStatus();
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }
  }

  suspend() {
    if (this.user.suspended === 0) {
      this.userUpdateStatusService.suspend(this.userId).subscribe(data => {
        this.dialog.showModal('showSuspendSuccessModalBtn');
        this.user = data;
        this.chRef.detectChanges();
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      });
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }
  }

  unsuspend() {
    if (this.user.suspended === 1) {
      this.userUpdateStatusService.unsuspend(this.userId).subscribe(data => {
        this.dialog.showModal('showUnuspendSuccessModalBtn');
        this.user = data;
        this.chRef.detectChanges();
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      });
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }
  }

  updateStatus() {
    this.userUpdateStatusService.update(this.userId).subscribe(data => {
      this.dialog.showModal('showSucModalBtn');
      this.user = data;
      this.chRef.detectChanges();

    },
    error => {
      this.exception.showError(error, 'showDanModalBtn');
    });
  }

  public hideDeactiveBtn(user: any) {
    const currentUser = this.userInfo.getLocalUser();
    const userObj = JSON.parse(currentUser);
    if (user.id === userObj.id && user.email === userObj.email) {
      this.deactivateBtn.nativeElement.style.display = 'none';
      this.suspendBtn.nativeElement.style.display = 'none';
    }
  }

  public hideEdit_BackBtn(user: any) {
    const currentUser = this.userInfo.getLocalUser();
    const userObj = JSON.parse(currentUser);
    if (user.id === userObj.id && userObj.role != Roles.Admin) {
      this.editBtn.nativeElement.style.display = 'none';
      this.backBtn.nativeElement.style.display = 'none';
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-detail/user-detail.component.ts